import renderHTML from 'react-render-html'

export default function formatPrice(figure, decimals, enableSuperScript){
	if (!decimals) decimals = 0
		const d = Math.pow(10, decimals)

	if (enableSuperScript) {
		let priceValue = parseInt(figure * d, 0) / d
				priceValue = priceValue.toFixed(decimals).split('.')

		return renderHTML(priceValue[0] + '<sup>.' + priceValue[1] + '</sup>')
	} else {
		return (parseInt(figure * d, 0) / d).toFixed(decimals)
	}
}

export function formatRoundPrice(figure, decimals, enableSuperScript){
	if (!decimals) decimals = 0
	const d = Math.round(10, decimals)

	if (enableSuperScript) {
		let priceValue = parseInt(figure * d, 0) / d
		priceValue = priceValue.toFixed(decimals).split('.')

		return renderHTML(priceValue[0] + '<sup>.' + priceValue[1] + '</sup>')
	} else {
		return parseFloat(figure).toFixed(2)
	}
}


// WEBPACK FOOTER //
// ./src/utilities/currency/formatPrice.js